import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-red.svg'
import _imports_1 from '@/app/ui/assets/svg/client-list.svg'


const _hoisted_1 = {
  class: "text-14px font-semibold xxl:text-16px",
  style: {"color":"#333"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-between border-b py-3 px-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Filter Pencarian klien "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-4",
    alt: "up"
  })
], -1)
const _hoisted_3 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Kota asal klien (3LC) ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Tipe Layanan Pengiriman ", -1)
const _hoisted_7 = { class: "gap-x-2 flex flex-row items-center w-full" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4",
  alt: "Daftar Klien"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Daftar Klien", -1)
const _hoisted_10 = {
  key: 0,
  class: "flex pt-1 flex-row items-center"
}
const _hoisted_11 = { class: "items-center w-full flex flex-wrap flex-row" }
const _hoisted_12 = { class: "bg-gray-lp-1100 flex flex-row items-center rounded px-2 py-1 mr-1 mb-2 whitespace-no-wrap" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-between border-b py-3 px-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Filter Pencarian klien "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-4",
    alt: "up"
  })
], -1)
const _hoisted_16 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Kota asal klien (3LC) ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }, " Tipe Layanan Pengiriman ", -1)
const _hoisted_20 = {
  class: "mt-5 flex relative w-full overflow-auto",
  style: {"max-height":"34rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: _ctx.compact ? 'flex flex-col gap-y-2' : 'flex flex-col mt-4 gap-x-4'
    }, [
      _createVNode("div", {
        class: _ctx.compact ? 'w-full' : 'bg-white w-full rounded-xl p-6',
        style: _ctx.compact ? '' : 'border: 1px solid #EBEBEB;'
      }, [
        _createVNode("p", _hoisted_1, _toDisplayString(_ctx.compact ? "Klien" : "Nama Klien"), 1),
        _createVNode("div", {
          class: 
            `flex flex-row items-center ${
              _ctx.isErrorClient || _ctx.errorMandatory ? 'mt-0' : 'mt-2'
            }`
          
        }, [
          (!_ctx.compact)
            ? (_openBlock(), _createBlock(_component_AdvancedFilter, {
                key: 0,
                "custom-max-height": "60vh",
                "model-value": _ctx.filterClient,
                isDisabled: _ctx.disabled,
                onOpened: _ctx.onOpenedAdvancedFilter,
                onReset: ($event: any) => (
              {
              }
            ),
                addSumFilter: _ctx.sumFilter,
                showIconFilter: true,
                showCountFilter: false,
                showChevron: false,
                isSeparateContent: "",
                customTitleFilter: "text-14px font-semibold text-gray-lp-300"
              }, {
                "custom-filter": _withCtx(() => [
                  _hoisted_2,
                  _createVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_SelectSearchV2, {
                      onFilter: _ctx.fetchCityDestination,
                      onFocus: _ctx.fetchCityDestination,
                      isLoading: _ctx.loadingCityDestination,
                      options: _ctx.cityDestinationData,
                      keyName: "name",
                      keyValue: "name",
                      placeholder: "Masukkan & pilih kota asal klien (3LC)",
                      modelValue: _ctx.filterClient.cityOriginCode,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                        _ctx.onChangeCityDestination
                      ]
                    }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue", "onUpdate:modelValue"]),
                    _hoisted_5,
                    _hoisted_6,
                    _createVNode(_component_MultipleSelectSearch, {
                      onChange: _ctx.onChangeShipmentType,
                      status: "active",
                      class: "my-1.5",
                      options: _ctx.optionsProduct,
                      placeholder: "Pilih tipe layanan pengiriman",
                      modelValue: _ctx.filterClient.shipmentType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                    }, null, 8, ["onChange", "options", "modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["model-value", "isDisabled", "onOpened", "addSumFilter"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_SelectSearch, {
              isFirstInput: true,
              options: _ctx.clients,
              onFocus: _ctx.onSearchValue,
              onFilter: _ctx.onSearchValue,
              keyName: "name",
              keyValue: "id",
              placeholder: "Masukkan & pilih nama/alias/kode klien cabang",
              modelValue: _ctx.modelValue.clientName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.clientName = $event)),
              isLoading: _ctx.isLoadingClients,
              onChange: _ctx.onChageClientName,
              isShowErrorMessage: false,
              isShowErrorIndicator: _ctx.isErrorClient || _ctx.errorMandatory,
              errorCaption: 
                _ctx.errorMandatory
                  ? 'Nama client wajib diisi'
                  : 'Client tidak dapat melakukan booking'
              ,
              class: [
                _ctx.compact
                  ? ''
                  : _ctx.isErrorClient || _ctx.errorMandatory
                  ? 'mt-8'
                  : 'my-2'
              , "w-full"],
              isDisabled: _ctx.disabled,
              disabledBackground: _ctx.disabled
            }, null, 8, ["options", "onFocus", "onFilter", "modelValue", "isLoading", "onChange", "isShowErrorIndicator", "errorCaption", "class", "isDisabled", "disabledBackground"]),
            (_ctx.compact)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "w-48 h-10 flex flex-row items-center justify-center gap-x-2 border border-gray-lp-600 text-gray-lp-300 bg-white py-1.5 font-semibold rounded-md focus:outline-none",
                  disabled: _ctx.disabled,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onShowPopupFilterClient(true)))
                }, [
                  _hoisted_8,
                  _hoisted_9
                ], 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_button_outline, {
                  key: 1,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onShowPopupFilterClient(true))),
                  title: "Daftar Klien",
                  custom: "w-48 border-gray-lp-600 text-gray-lp-300 bg-white",
                  style: {"height":"40px"},
                  class: "mr-4",
                  isDisabled: _ctx.disabled
                }, null, 8, ["isDisabled"]))
          ])
        ], 2),
        (!_ctx.compact)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summaryFilter, (item, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(item.value) + " ", 1),
                      _createVNode(_component_Icons, {
                        onClick: ($event: any) => (_ctx.onDeleteSummary(item.from)),
                        name: "icon-x",
                        class: "ml-2 w-4 text-gray-lp-600 cursor-pointer"
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128)),
                (_ctx.summaryFilter.length)
                  ? (_openBlock(), _createBlock("p", {
                      key: 0,
                      class: "text-14px font-semibold font-montserrat cursor-pointer mb-2",
                      style: {"color":"#B82025"},
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onResetFilter && _ctx.onResetFilter(...args)))
                    }, " Reset "))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 6),
      _hoisted_13
    ], 2),
    (_ctx.showPopupFilterClient)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-8/12",
          showBorderTitle: false,
          showFooter: false,
          scrollable: false,
          title: "Daftar klien",
          onClose: () => _ctx.onClosePopupFilter()
        }, {
          content: _withCtx(() => [
            (!_ctx.isErrorGetClient)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode(_component_AdvancedFilter, {
                    "custom-max-height": "60vh",
                    "model-value": _ctx.filterClient,
                    isDisabled: false,
                    onOpened: _ctx.onOpenedAdvancedFilter,
                    onReset: ($event: any) => (
              {
              }
            ),
                    addSumFilter: _ctx.sumFilter,
                    showIconFilter: true,
                    showCountFilter: false,
                    showChevron: false,
                    isSeparateContent: "",
                    customTitleFilter: "text-14px font-semibold text-gray-lp-300"
                  }, {
                    "custom-filter": _withCtx(() => [
                      _hoisted_15,
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_SelectSearchV2, {
                          onFilter: _ctx.fetchCityDestination,
                          onFocus: _ctx.fetchCityDestination,
                          isLoading: _ctx.loadingCityDestination,
                          options: _ctx.cityDestinationData,
                          keyName: "name",
                          keyValue: "name",
                          placeholder: "Masukkan & pilih kota asal klien (3LC)",
                          modelValue: _ctx.filterClient.cityOriginCode,
                          "onUpdate:modelValue": [
                            _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                            _ctx.onChangeCityDestination
                          ]
                        }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue", "onUpdate:modelValue"]),
                        _hoisted_18,
                        _hoisted_19,
                        _createVNode(_component_MultipleSelectSearch, {
                          onChange: _ctx.onChangeShipmentType,
                          status: "active",
                          class: "my-1.5",
                          options: _ctx.optionsProduct,
                          placeholder: "Pilih tipe layanan pengiriman",
                          modelValue: _ctx.filterClient.shipmentType,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                        }, null, 8, ["onChange", "options", "modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model-value", "onOpened", "addSumFilter"]),
                  _createVNode(_component_Search, {
                    class: "w-full",
                    onInput: search => _ctx.onSearchValue(search, true),
                    onClear: _ctx.clearSearch,
                    value: _ctx.searchValue,
                    placeholder: "Cari berdasarkan nama/alias klien",
                    colorIcon: "#4D4D4D"
                  }, null, 8, ["onInput", "onClear", "value"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                onRequest: _cache[9] || (_cache[9] = 
              () =>
                _ctx.fetchdDataClients({ isDirectory: true, infiniteScroll: true })
            ),
                data: _ctx.clients,
                loading: _ctx.isLoadingClients,
                errorCause: _ctx.isErrorGetClient,
                isDetailAble: "",
                onClick: (item) => _ctx.goToDetail(item),
                paginationStyle: "v3",
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[10] || (_cache[10] = ($event: any) => (_ctx.pagination = $event)),
                borderTop: false,
                borderBottom: false,
                isEmpty: _ctx.isEmpty,
                bgHeader: "bg-white",
                hidePagination: "",
                isNoPaddingBottom: "",
                infiniteScroll: ""
              }, null, 8, ["columns", "data", "loading", "errorCause", "onClick", "pagination", "isEmpty"])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}